import "./AppBtn.scss";
import Routable from "@/core/mixins/routable";
import ProgressCircular from "@/components/ui/progress/ProgressCircular";

export default {
  mixins: [Routable],

  props: {
    tag: {
      type: String,
      default: "div"
    },
    type: {
      type: String,
      default: "button"
    },
    activeClass: {
      type: String,
      default: "btn_active"
    },
    color: {
      type: String,
      default: null
    },
    border: {
      type: [Boolean, String],
      default: false,
      required: false,
      validator: function(value) {
        return (
          ["left", "right", "top", "bottom"].indexOf(value) !== -1 ||
          typeof value == "boolean"
        );
      }
    },
    block: Boolean,
    icon: Boolean,
    iconOnly: Boolean,
    link: Boolean,
    outline: Boolean,
    round: Boolean,
    ellipsis: Boolean,
    loading: Boolean,
    value: null
    // depressed: Boolean,
  },

  watch: {
    $route: "onRouteChange"
  },

  computed: {
    classes() {
      return {
        btn: true,
        [this.activeClass]: this.isActive,
        btn_disabled: this.disabled,
        btn_block: this.block,
        btn_icon: this.icon || this.iconOnly,
        btn_icon_only: this.iconOnly,
        btn_link: this.link,
        btn_outline: this.outline,
        btn_round: this.round,
        btn_border: this.border,
        btn_loading: this.loading,
        [`btn_border_${this.border}`]: typeof this.border == "string",
        [`btn_${this.color}`]: !!this.color,

        btn_router: this.to
      };
    }
  },

  methods: {
    genContent() {
      return this.$createElement(
        "div",
        {
          staticClass: "btn__content",
          class: {
            ellipsis: this.ellipsis
          }
        },
        this.$slots.default
      );
    },

    genLoader() {
      return this.$createElement(
        "span",
        { class: "btn__loader" },
        this.$slots.loader || [
          this.$createElement(ProgressCircular, {
            props: {
              indeterminate: true,
              size: 23,
              width: 3
            }
          })
        ]
      );
    },

    onRouteChange() {}
  },

  render(h) {
    const { tag, data } = this.generateRouteLink(this.classes);
    const children = [this.genContent(), this.loading && this.genLoader()];
    if (tag === "button") data.attrs.type = this.type;

    data.attrs.value = ["string", "number"].includes(typeof this.value)
      ? this.value
      : JSON.stringify(this.value);

    if (this.btnToggle) {
      data.ref = "link";
    }

    return h(tag, data, children);
  }
};
